import React, { useEffect, useState } from 'react';
import { Button, Card, Row } from 'antd';
import StudentModal from './StudentModal';
const { Meta } = Card;
const StudentCard = ({
    data,
    onClick = () => {

    }
}) => {
    const [open, setOpen] = useState()
    useEffect(() => {
        setOpen(false)
    }, [])
    return (<>
        <StudentModal open={open} data={data} onCancel={() => setOpen(false)} onOk={() => { console.log("ok"); setOpen(false) }} onClick={onClick} />
        <Button
            type='link'
            style={{
                height: "auto"
            }}
            onClick={() => {
                setOpen(true)
            }}
        >
            <Card>
                <img
                    style={{
                        position: "relative",
                        height: "100px",
                        width: "100px",
                        overflow: "hidden",
                        borderRadius: "50%",
                        padding: "5%"
                    }}
                    draggable={false}
                    alt="example"
                    src={data.src} />
                <Meta style={{ padding: "5%" }} title={data.name} />
            </Card>
        </Button >
    </>)
};
export default StudentCard;